import { render, staticRenderFns } from "./StudyDetailTable.vue?vue&type=template&id=4ba4a7d9&scoped=true&lang=pug"
import script from "./StudyDetailTable.vue?vue&type=script&lang=ts"
export * from "./StudyDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyDetailTable.vue?vue&type=style&index=0&id=4ba4a7d9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba4a7d9",
  null
  
)

export default component.exports